import { EuiFieldText, EuiFormRow } from "@inscopix/ideas-eui";

interface FieldTableNameProps {
  autoFocus?: boolean;
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (field: { value: string; isValid: boolean }) => void;
}

export const FieldTableName = ({
  autoFocus,
  label = "Name",
  placeholder = "",
  value,
  onChange,
}: FieldTableNameProps) => {
  return (
    <EuiFormRow fullWidth label={label}>
      <EuiFieldText
        aria-label="Table name"
        fullWidth
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          const newName = e.target.value;
          onChange({
            value: newName,
            isValid: newName !== "",
          });
        }}
        icon="copyClipboard"
        maxLength={255}
        isInvalid={false}
        autoFocus={autoFocus}
      />
    </EuiFormRow>
  );
};
